/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../../app/components/common/errorsSummary/errorsSummary.component';
const styles_ErrorsSummaryComponent:any[] = ([] as any[]);
export const RenderType_ErrorsSummaryComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ErrorsSummaryComponent,data:{}});
function View_ErrorsSummaryComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'li',[['class',
      'text-danger']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' ',' ']))],(null as any),(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ErrorsSummaryComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'ul',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_ErrorsSummaryComponent_1)),i0.ɵdid(802816,(null as any),
      0,i1.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,
          'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
      i0.ɵted((null as any),[' ']))],(_ck,_v) => {
    var _co:i2.ErrorsSummaryComponent = _v.component;
    const currVal_0:any = _co.getErrors();
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
export function View_ErrorsSummaryComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'errors-summary',
      ([] as any[]),(null as any),(null as any),(null as any),View_ErrorsSummaryComponent_0,
      RenderType_ErrorsSummaryComponent)),i0.ɵdid(49152,(null as any),0,i2.ErrorsSummaryComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const ErrorsSummaryComponentNgFactory:i0.ComponentFactory<i2.ErrorsSummaryComponent> = i0.ɵccf('errors-summary',
    i2.ErrorsSummaryComponent,View_ErrorsSummaryComponent_Host_0,{errors:'errors'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2Vycm9yc1N1bW1hcnkvZXJyb3JzU3VtbWFyeS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2Vycm9yc1N1bW1hcnkvZXJyb3JzU3VtbWFyeS5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9jb21tb24vZXJyb3JzU3VtbWFyeS9lcnJvcnNTdW1tYXJ5LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvY29tbW9uL2Vycm9yc1N1bW1hcnkvZXJyb3JzU3VtbWFyeS5jb21wb25lbnQudHMuRXJyb3JzU3VtbWFyeUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjx1bD4gPGxpIGNsYXNzPVwidGV4dC1kYW5nZXJcIiAqbmdGb3I9XCJsZXQgZXJyb3Igb2YgZ2V0RXJyb3JzKClcIj4ge3tlcnJvcn19IDwvbGk+IDwvdWw+ICIsIjxlcnJvcnMtc3VtbWFyeT48L2Vycm9ycy1zdW1tYXJ5PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNBSztNQUFBO01BQTBEO0lBQUE7SUFBQTs7OztvQkFBL0Q7TUFBQSx3RUFBSTthQUFBLHVCQUFDO01BQUEsdURBQUE7TUFBQTtVQUFBLDJCQUEwRSxzQ0FBTTthQUFBOztJQUF4RDtJQUF4QixXQUF3QixTQUF4Qjs7OztvQkNBTDtNQUFBO3VDQUFBLFVBQUE7TUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./compiled/app/components/common/errorsSummary/errorsSummary.component.ngfactory.ts